"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var Row_1 = require("./Row");

var react_2 = require("@emotion/react");

var GridRoot = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex: 0 0 auto;\n\tpadding: 0;\n\tmargin: 0;\n\tflex-direction: column;\n\tbox-sizing: border-box;\n\n\t", "\n"])), function (props) {
  var gutter = props.gutter,
      style = props.css;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tmargin: -", "px;\n\t\t\t", ";\n\t\t"])), gutter, style && style.styles);
});

var Grid = function Grid(_ref) {
  var children = _ref.children,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 5 : _ref$gutter,
      style = _ref.style,
      dataTestId = _ref.dataTestId;
  var rows = react_1.default.Children.map(children, function (item) {
    return (0, jsx_runtime_1.jsx)(Row_1.Row, Object.assign({
      gutter: gutter
    }, item === null || item === void 0 ? void 0 : item.props, {
      children: item
    }));
  });
  return (0, jsx_runtime_1.jsx)(GridRoot, {
    gutter: gutter,
    css: style,
    "data-testid": dataTestId,
    children: rows
  });
};

exports.Grid = Grid;